import React, { useState } from 'react';
import { BASE_URL } from '../../config/config';

const RateReviewModal = ({ isOpen, onClose, items, onSubmitReview, itemRatings = {} }) => {
  const [selectedItem, setSelectedItem] = useState('');
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [hoveredStar, setHoveredStar] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Filter out items that are already rated
  const unratedItems = items.filter(item => !itemRatings[item.id]);

const handleSubmit = async () => {
  if (!selectedItem || rating === 0) {
    alert('Please select an item and provide a rating');
    return;
  }

  const selectedItemData = unratedItems.find(item => item.id === selectedItem);

  const token = localStorage.getItem('token');
  const user_id = localStorage.getItem('user_id');

  if (!token || !user_id) {
    alert('User not authenticated');
    return;
  }

  const reviewData = {
    user_id,
    product_id: selectedItemData.id, // use .id here
    stars: rating.toString(),
    review
  };


  try {
    const response = await fetch(`${BASE_URL}/rating`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(reviewData)
    });

    const data = await response.json();
    if (response.status === 201) {
      alert(data.message || 'Rating submitted successfully');
      setSelectedItem('');
      setRating(0);
      setReview('');
      onClose();

      if (onSubmitReview) onSubmitReview(reviewData);
    } else {
      alert(data.message || 'Failed to submit rating');
    }
  } catch (error) {
    alert('Something went wrong. Please try again.');
  }
};



  const handleStarClick = (starIndex) => {
    setRating(starIndex);
  };

  const handleStarHover = (starIndex) => {
    setHoveredStar(starIndex);
  };

  const handleStarLeave = () => {
    setHoveredStar(0);
  };

  const handleItemSelect = (itemId) => {
    setSelectedItem(itemId);
    setIsDropdownOpen(false);
  };

  const selectedItemData = unratedItems.find(item => item.id === selectedItem);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-sky-950">Rate & Review</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {/* Custom Item Selection Dropdown */}
        <div className="mb-6">
          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="w-full p-3 border border-gray-300 rounded-lg bg-white text-sky-950 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-left flex items-center justify-between"
            >
              {selectedItemData ? (
                <div className="flex items-center gap-3">
                  <img
                    src={selectedItemData.image}
                    alt={selectedItemData.name}
                    className="w-6 h-6 rounded-md object-contain"
                  />
                  <span className="text-sm text-sky-950">
                    {selectedItemData.name}
                  </span>
                </div>
              ) : (
                <span className="text-gray-500">Choose an item...</span>
              )}
              <svg
                className={`w-5 h-5 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Dropdown Options */}
            {isDropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                {unratedItems.length === 0 ? (
                  <div className="p-3 text-gray-500 text-sm">No items available to rate</div>
                ) : (
                  unratedItems.map((item, index) => (
                    <button
                      key={item.id}
                      onClick={() => handleItemSelect(item.id)}
                      className="w-full p-3 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none flex items-center gap-3 border-b border-gray-100 last:border-b-0"
                    >
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-8 h-8 rounded-md object-contain flex-shrink-0"
                      />
                      <span className="text-sm text-sky-950">
                        {item.name} {unratedItems.filter(i => i.name === item.name).length > 1 ? `(${index + 1})` : ''}
                      </span>
                    </button>
                  ))
                )}
              </div>
            )}
          </div>
        </div>

        {/* Star Rating */}
        <div className="mb-6">
          <div className="flex gap-2 justify-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                onClick={() => handleStarClick(star)}
                onMouseEnter={() => handleStarHover(star)}
                onMouseLeave={handleStarLeave}
                className="text-4xl focus:outline-none transition-colors duration-150 hover:scale-110 transform"
                style={{ fontSize: '2.5rem' }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill={star <= (hoveredStar || rating) ? '#fbbf24' : '#d1d5db'}
                  className="transition-colors duration-150"
                >
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    stroke={star <= (hoveredStar || rating) ? '#f59e0b' : '#9ca3af'}
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            ))}
          </div>
          {rating > 0 && (
            <p className="text-center text-sm text-gray-600 mt-2">
              {rating} out of 5 stars
            </p>
          )}
        </div>

        {/* Review Text */}
        <div className="mb-6">
          <textarea
            value={review}
            onChange={(e) => setReview(e.target.value)}
            placeholder="Write your review"
            rows={4}
            className="w-full p-3 border-0 border-b border-gray-300 text-sky-950 focus:outline-none focus:border-b-2 focus:border-green-500 resize-none bg-transparent"
            style={{
              borderTop: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderRadius: '0'
            }}
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          className="w-full flex gap-10 justify-center items-center px-5 py-4 rounded-2xl border-b border-white border-opacity-30 min-h-[50px] transition-all duration-200 hover:text-neutral-600 hover:bg-zinc-300 text-white bg-green-500 hover:shadow-lg font-semibold tracking-wide leading-tight text-center"
        >
          <span>Submit Review</span>
        </button>
      </div>
    </div>
  );
};

export default RateReviewModal;
